"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hotspot = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importStar(require("react"));
var debug_1 = require("../debug");
var types_1 = require("../types");
var useDashboardDrop_1 = require("../useDashboardDrop");
var useInsightListItemDropHandler_1 = require("./useInsightListItemDropHandler");
var useInsightPlaceholderDropHandler_1 = require("./useInsightPlaceholderDropHandler");
var useKpiPlaceholderDropHandler_1 = require("./useKpiPlaceholderDropHandler");
var useMoveWidgetHandler_1 = require("./useMoveWidgetHandler");
var useWidgetDragHoverHandlers_1 = require("./useWidgetDragHoverHandlers");
exports.Hotspot = function (props) {
    var itemIndex = props.itemIndex, sectionIndex = props.sectionIndex, classNames = props.classNames, dropZoneType = props.dropZoneType, isEndingHotspot = props.isEndingHotspot;
    var isOverLastValue = react_1.useRef(false);
    // for "next" we need to add the item after the current index, for "prev" on the current one
    var targetItemIndex = dropZoneType === "next" ? itemIndex + 1 : itemIndex;
    var handleInsightListItemDrop = useInsightListItemDropHandler_1.useInsightListItemDropHandler(sectionIndex, targetItemIndex);
    var handleInsightPlaceholderDrop = useInsightPlaceholderDropHandler_1.useInsightPlaceholderDropHandler(sectionIndex, targetItemIndex);
    var handleKpiPlaceholderDrop = useKpiPlaceholderDropHandler_1.useKpiPlaceholderDropHandler(sectionIndex, targetItemIndex);
    var handleWidgetDrop = useMoveWidgetHandler_1.useMoveWidgetDropHandler(sectionIndex, targetItemIndex);
    var handleDragHoverStart = useWidgetDragHoverHandlers_1.useWidgetDragHoverHandlers().handleDragHoverStart;
    var _a = tslib_1.__read(useDashboardDrop_1.useDashboardDrop(["insightListItem", "kpi-placeholder", "insight-placeholder", "kpi", "insight"], {
        drop: function (item) {
            if (types_1.isInsightDraggableListItem(item)) {
                handleInsightListItemDrop(item.insight);
            }
            if (types_1.isKpiPlaceholderDraggableItem(item)) {
                handleKpiPlaceholderDrop();
            }
            if (types_1.isInsightPlaceholderDraggableItem(item)) {
                handleInsightPlaceholderDrop();
            }
            if (types_1.isInsightDraggableItem(item) || types_1.isKpiDraggableItem(item)) {
                handleWidgetDrop(item);
            }
        },
    }, [
        targetItemIndex,
        sectionIndex,
        handleInsightListItemDrop,
        handleInsightPlaceholderDrop,
        handleKpiPlaceholderDrop,
        handleWidgetDrop,
    ]), 2), _b = _a[0], canDrop = _b.canDrop, isOver = _b.isOver, item = _b.item, dropRef = _a[1];
    react_1.useEffect(function () {
        if (isOver) {
            handleDragHoverStart({ sectionIndex: sectionIndex, itemIndex: targetItemIndex });
            isOverLastValue.current = isOver;
        }
    }, [isOver, sectionIndex, targetItemIndex, handleDragHoverStart]);
    var debugStyle = debug_1.getDropZoneDebugStyle({ isOver: isOver });
    var canDropSafe = react_1.useCallback(function (item) {
        if (!item) {
            return false;
        }
        if (types_1.isInsightDraggableItem(item) || types_1.isKpiDraggableItem(item)) {
            return isEndingHotspot || item.sectionIndex !== sectionIndex || item.itemIndex !== itemIndex;
        }
        return true;
    }, [isEndingHotspot, sectionIndex, itemIndex]);
    return (react_1.default.createElement("div", { className: classnames_1.default(classNames, "dropzone", dropZoneType, {
            hidden: !canDrop || !canDropSafe(item),
            full: isEndingHotspot,
        }), style: debugStyle, ref: dropRef }));
};
//# sourceMappingURL=Hotspot.js.map